import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import Service from "../../../assets/img/Featured/pc-graphs.png";
import PMS from "../../../assets/img/Featured/pc-office.png";
import Service2 from "../../../assets/img/Featured/app-service2-tall.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const OfficePage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page officePage">
            <div className="page-header">Hotel</div>
            <Header />
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Back Office</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Achieving High Return Hospitality demands an
                    effective combination of delivering excellence at
                    every guest interaction and optimizing internal
                    operations to ensure that guest and transactional
                    information is flowing seamlessly among systems
                    and staff leading to maximum revenue per guest.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Office", "PMS");
                    addFlow("PMS");
                    navigate("/solutions/pms")}}>
                    <img src={PMS} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        PMS
                    </div>
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Office", "Service");
                    addFlow("Service");
                    navigate("/solutions/service")}}>
                    <img src={Service} alt="" />
                    <img src={Service2} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Service
                    </div>
                </div>
            </FeaturedSolutions>
        </div>
    )
}

export default OfficePage;